<ngx-material-timepicker-face [faceTime]="minutesList" [selectedTime]="selectedMinute"
                              [minutesGap]="minutesGap"
                              (timeChange)="minuteChange.next($event)" [unit]="timeUnit.MINUTE"></ngx-material-timepicker-face>
